import { z } from "zod";
import { COLLECTION_STATUS, memberDueStatusSchema } from "./collections.js";

/* ===========================================================================
 * US-E6.F8-0046 — Collection Period Status (@UC0059)
 * GET /v1/collections/:id/status — tiến độ đợt thu (aggregate).
 *
 * PRIVACY (AC4): response là AGGREGATE-ONLY (đếm + %) + status của CHÍNH caller.
 * KHÔNG có field amountMinor/số tiền của due NGƯỜI KHÁC — enforce bằng SHAPE (không tồn tại field).
 * Read-only, KHÔNG post ledger.
 * ========================================================================= */

export const collectionPeriodStatusResponseSchema = z
  .object({
    collectionId: z.string().uuid(),
    collectionName: z.string().nullable(),
    /**
     * Số member PHẢI ĐÓNG trong đợt (Y) = số due **KHÔNG** `waived` (US-E6.F8-0862, QĐ người dùng
     * 29/09/2026 — người được miễn không kỳ vọng thu). Trùng `collection-progress.totalMembers`.
     */
    totalMembers: z.number().int().nonnegative(),
    /** Số member đã đóng — paid + paid_on_behalf (X). */
    paidMembers: z.number().int().nonnegative(),
    /**
     * Tiến độ % = paidMembers/totalMembers*100. Số nguyên 0..100. `totalMembers = 0` ⇒ 0, trừ đợt có
     * due mà MỌI due đều `waived` ⇒ 100 (không còn ai phải đóng — US-E6.F8-0862 Q1).
     */
    progressPercent: z.number().int().min(0).max(100),
    /** Số ngày còn lại đến dueDate (âm = quá hạn N ngày). null nếu đợt không có dueDate. */
    daysLeft: z.number().int().nullable(),
    /** true nếu dueDate đã qua (daysLeft < 0). */
    isOverdue: z.boolean(),
    /** Status đóng tiền của CHÍNH caller (highlight). null nếu caller không có due trong đợt. */
    myStatus: memberDueStatusSchema.nullable(),
    /**
     * 🔴 US-E24.F2-0351-S03 (@UC9567) — trạng thái VÒNG ĐỜI CỦA ĐỢT (`open | closed`): nguồn cho
     * badge "kỳ trước / đã chốt". Tách bạch tuyệt đối với `myStatus` (trạng thái DUE của caller):
     * một kỳ `closed` mà due của tôi vẫn `pending` là chuyện có thật và phải đọc ra được.
     */
    collectionStatus: z.enum([COLLECTION_STATUS.OPEN, COLLECTION_STATUS.CLOSED]),
  })
  .strict();

export type CollectionPeriodStatusResponse = z.infer<
  typeof collectionPeriodStatusResponseSchema
>;
